// Не забудьте импортировать createTheme
import { createTheme } from '@mui/material/styles';
import Fade from '@mui/material/Fade';
import {
  MOTION,
  PRESS_SX,
  REDUCED_MOTION,
  SKELETON_BG,
  SKELETON_WAVE,
  SKELETON_WAVE_SECONDS,
  dialogIn,
  menuIn,
} from './styles/tokens';

const darkTheme = createTheme({
  palette: {
    mode: 'dark',
    primary: {
      main: '#4a90e2',
    },
    secondary: {
      main: '#ff4081',
    },
    background: {
      default: '#121212',
      paper: '#1d1d1d',
    },
    text: {
      primary: '#ffffff',
      secondary: '#b0b0b0',
    },
  },
  typography: {
    fontFamily: `'Nunito', 'JetBrains Mono', sans-serif`,
  },
  components: {
    // Скелетоны загрузки: фон, перелив слева направо за 1.4 с; без движения при reduced motion
    MuiSkeleton: {
      defaultProps: { animation: 'wave' },
      styleOverrides: {
        root: { backgroundColor: SKELETON_BG },
        wave: {
          '&::after': {
            background: SKELETON_WAVE,
            animationDuration: `${SKELETON_WAVE_SECONDS}s`,
            animationDelay: '0s',
            animationTimingFunction: 'linear',
          },
          [REDUCED_MOTION]: { '&::after': { animation: 'none' } },
        },
      },
    },
    // Нажатие на любую кнопку MUI (Button, IconButton, ButtonBase, пункты меню и навигации) — scale 0.98
    MuiButtonBase: {
      styleOverrides: { root: PRESS_SX },
    },
    // Выпадающие меню и поповеры: fade + сдвиг сверху на 4px за MOTION.fast (вместо Grow)
    MuiPopover: {
      defaultProps: { TransitionComponent: Fade, transitionDuration: MOTION.fast },
      styleOverrides: {
        paper: {
          animation: `${menuIn} ${MOTION.fast}ms ${MOTION.easing}`,
          [REDUCED_MOTION]: { animation: 'none', transition: 'none !important' },
        },
      },
    },
    // Диалоги (на десктопе; на телефоне ResponsiveDialog — лист снизу): fade + scale 0.97 → 1 за 180 мс
    MuiDialog: {
      defaultProps: { transitionDuration: MOTION.dialog },
      styleOverrides: {
        paper: {
          animation: `${dialogIn} ${MOTION.dialog}ms ${MOTION.easing}`,
          [REDUCED_MOTION]: { animation: 'none' },
        },
      },
    },
    // Menu передаёт в Popover свою длительность ('auto' — только для Grow)
    MuiMenu: {
      defaultProps: { transitionDuration: MOTION.fast },
    },
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: '8px',
          textTransform: 'none',
          fontSize: '1rem',
          padding: '10px 20px',
          boxShadow: '0px 4px 8px rgba(0, 0, 0, 0.2)',
          '&:hover': {
            boxShadow: '0px 6px 12px rgba(0, 0, 0, 0.3)',
          },
        },
      },
    },
    MuiTextField: {
      styleOverrides: {
        root: {
          backgroundColor: '#333333',
          color: '#ffffff',
          marginBottom: '16px',
          borderRadius: '8px',
          '& .MuiOutlinedInput-root': {
            '& fieldset': {
              borderColor: '#4a90e2',
            },
            '&:hover fieldset': {
              borderColor: '#357ABD',
            },
            '&.Mui-focused fieldset': {
              borderColor: '#4a90e2',
            },
          },
          '& .MuiInputBase-input': {
            color: '#ffffff',
          },
          '& .MuiInputLabel-root': {
            color: '#b0b0b0',
          },
        },
      },
    },
  },
});

// Экспорт темы для использования в других частях приложения
export default darkTheme;
